import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelMetaGuideIndex from './Index.vue';

// The owner's Messenger/Instagram connection guide. Administrators only, and
// the server additionally limits it to the accounts in
// TELETEL_META_GUIDE_ACCOUNT_IDS; the sidebar hides it elsewhere.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-meta-guide'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'teletel_meta_guide', params: to.params }),
        },
        {
          path: 'list',
          name: 'teletel_meta_guide',
          meta: {
            permissions: ['administrator'],
          },
          component: TeletelMetaGuideIndex,
        },
      ],
    },
  ],
};
